module.exports = __webpack_public_path__ + "img/144ne.47630896.svg";